import Hook from "../../utils/hook"
import { createSortableList } from "../../utils/sortable-list"

// reorders the trip's objects by dragging their handles; the new order is sent
// to the server, which validates and saves it, and the objects are put back
// when it's rejected. `itemIds` is the current order. The arrow keys on a
// handle move its object like the up/down buttons do
export const TripEditPageObjects = Hook(`TripEditPageObjects`, {
  values: { itemIds: Array, draggingClass: String },
  targets: [`item`, `handle`],
  actions: [{ name: `handleKey`, targets: `handle`, type: `keydown` }],
  sortable: null,

  mounted() {
    // Sortable adds its own listeners, removed by `destroy()`
    this.sortable = createSortableList(this.el, {
      item: `[data-TripEditPageObjects-target="item"]`,
      handle: `[data-TripEditPageObjects-target="handle"]`,
      draggingClass: this.draggingClassValue,
      ids: () => this.itemIdsValue,
      items: () => this.itemTargets,
      onReorder: (ids, restore) =>
        this.pushEvent(`reorder_trip_items`, { ids }, ({ ok }) => {
          if (!ok) restore()
        }),
    })
  },

  destroyed() {
    this.sortable?.destroy()
    this.sortable = null
  },

  handleKeyAction(e, node) {
    const direction = { ArrowUp: `up`, ArrowDown: `down` }[e.key]
    if (!direction) return

    const id = this.itemIdsValue[this.handleTargets.indexOf(node)]
    if (id == null) return

    e.preventDefault()
    this.pushEvent(`move_trip_item`, { id, direction })
  },
})
